import { useState, useMemo, useEffect } from 'react';
import { Table, Form, Button, InputGroup, Row, Col, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRules } from '../utils/api';
import Header from './Header';
import Avatar from './Avatar';
import Loader from './Loader';
import { faGavel, faPencil, faTrashCan, faX } from '@fortawesome/free-solid-svg-icons';
import ShowMenuButton from './ShowMenuButton';
import CreateEditUserModal from './Modals/CreateEditUserModal';
import { tableSort } from '../utils/helpers';
import Error from './Error';
import { useDataStore } from '../Store';
import EditRulesModal from './Modals/EditRulesModal';
import ViewRuleModal from './Modals/ViewRuleModal';

const Rules = () => {

    const selectedEntity = useDataStore((state) => state.selectedEntity);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);

    const [selectedRule, setSelectedRule] = useState(null);
    const [showEditRulesModal, setShowEditRulesModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        await fetchTableData();
        setLoading(false);
    };
    const fetchSearchData = async () => {
        setSearchLoading(true);
        await fetchTableData();
        setSearchLoading(false);
    };

    const fetchTableData = async () => {
        const data = await getRules(selectedEntity, page, 50, searchText);
        if (data) {
            setData(data);
        }
        else {
            setError('Failed to fetch data');
        }
    };

    useEffect(() => {
        fetchSearchData();
    }, [searchText, page]);



    const rowClicked = (o) => {
        setSelectedRule(o);
        setShowViewModal(true);
    };
    const handleActionClick = (name, o) => {

        if (name === 'View') {
            rowClicked(o);
            return;
        }

        if (name === 'Edit') {
            setSelectedRule(o);
            setShowEditRulesModal(true);
            return;
        }
    }
    const lastPage = data.LastPage;

    return (
        <div style={{ padding: 10 }}>
            {loading ? <Loader /> : error ? <Error /> : (
                <>
                    <Header title='Rules' description="Manage rules for each state or territory." />
                    <Row className="mb-3">
                        <Col md={12}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Search rules..."
                                    value={searchText}
                                    onChange={(e) => {
                                        setPage(1);
                                        setSearchText(e.target.value)
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            setPage(1);
                                            fetchSearchData();
                                        }
                                    }}
                                />
                                <Button variant="outline-secondary" onClick={fetchSearchData}>
                                    Search
                                </Button>
                            </InputGroup>
                        </Col>
                    </Row>

                    {searchLoading ? <Loader /> : (
                        <>
                            <Row className="mb-3 mt-3">
                                <Col>
                                    <div style={{ overflowX: 'auto', width: '100%' }}>
                                        <Table striped bordered hover style={{ minHeight: 190, overflow: 'visible' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        ID
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        State
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        Process Trade In
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        Description
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        Max Over Match
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>
                                                        Max Under Match
                                                    </th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.Results?.map((d, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.Id}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.State?.Name}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.ProcessTradeIn ? "Yes" : "No"}</td>
                                                        <td style={{ whiteSpace: 'normal', width: '100%', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.Description}</td>
                                                        <td style={{ whiteSpace: 'normal', width: '100%', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.MaxOverMatch}</td>
                                                        <td style={{ whiteSpace: 'normal', width: '100%', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => rowClicked(d)}>{d?.MaxUnderMatch}</td>
                                                        <td style={{ whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}>{<ShowMenuButton menuItems={[
                                                            { icon: <FontAwesomeIcon icon={faGavel} />, name: 'View', target: d, onClick: handleActionClick },
                                                            { icon: <FontAwesomeIcon icon={faPencil} />, name: 'Edit', target: d, onClick: handleActionClick }
                                                        ]} />}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-3 mt-3">
                                <Col className="d-flex justify-content-center">
                                    <Pagination>
                                        <Pagination.First disabled={page <= 1} onClick={() => setPage(1)} />
                                        <Pagination.Prev disabled={page <= 1} onClick={() => setPage(page - 1)} />
                                        <Pagination.Item key={page} active={true}>
                                            {page}
                                        </Pagination.Item>
                                        <Pagination.Next disabled={page >= lastPage} onClick={() => setPage(page + 1)} />
                                        <Pagination.Last disabled={page >= lastPage} onClick={() => setPage(lastPage)} />
                                    </Pagination>
                                </Col>
                            </Row>

                        </>
                    )}

                    <ViewRuleModal
                        show={showViewModal}
                        onHide={() => setShowViewModal(false)}
                        rule={selectedRule}
                    />

                    <EditRulesModal
                        show={showEditRulesModal}
                        onHide={(shouldRefresh) => {
                            setShowEditRulesModal(false);
                            if (shouldRefresh)
                                fetchData();
                        }}
                        rule={selectedRule}
                    />
                </>
            )}
        </div>
    );
};

export default Rules;
